// extracted by mini-css-extract-plugin
module.exports = {"base":"NotesCard_base__1SqwA"};